

















































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { ILead } from "@/models/leads";
import { mapGetters } from "vuex";
import { DataModules } from "@/store/modules/data";
import Context from "@/mixins/context";
import { ApiOperators } from "@/data/table";

enum Action {
  SEARCH = "search",
  LIST = "list"
}

@Component({
  components: {
    "lead-vessel": () => import("@/components/app/admin/leads/leadVessel.vue")
  },
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  }
})
export default class LeadSearch extends Mixins(RequestPromises, Context) {
  public $refs!: {
    search: HTMLFormElement;
  };
  @Prop({
    required: false,
    default: () => []
  })
  public excludedLeadsIds!: ILead["id"][];
  @Prop({
    required: false,
    default: () => ({})
  })
  public lead!: ILead;
  public processing = false;
  public leadSearchValue = "";
  @Prop({ required: false, default: false })
  public onlyVerified!: boolean;
  public isMultibrand!: boolean;
  public leads: ILead[] = [];
  public loading = false;
  public initialLoading = true;
  public dataScope = "leadsSearch";
  public config = {
    paginated: true,
    limit: 5,
    offset: 0,
    total: 5,
    page: 1,
    action: Action.LIST
  };

  public getAsyncData = this.$_.debounce(async (name: string) => {
    await this.loadLeads({
      query: name
    });
  }, 250);

  public created() {
    this.loadLeads({}).finally(() => (this.initialLoading = false));
  }

  @Watch("initialLoading")
  public focusSearchBar() {
    if (this.initialLoading) {
      return;
    }
    this.$nextTick(() => this.$refs.search.focus());
  }

  public beforeDestroy() {
    this.$store.dispatch("data/bin", {
      storeModule: DataModules.LEADS,
      scope: this.dataScope,
      vm: this
    });
  }

  public onLeadSelected(lead) {
    if (this.lead && this.lead.id === lead.id) {
      return this.$emit("close");
    }
    this.$emit("lead-selected", lead);
  }

  public onPageChange(page: number) {
    if (this.leads.length === 0) {
      return;
    }
    this.config.page = page;

    this.loadLeads({
      query: this.leadSearchValue,
      offset: (this.config.page - 1) * this.config.limit
    });
  }

  public onLimitChange(limit: number) {
    if (this.leads.length === 0) return;
    this.config.limit = limit;
    this.loadLeads({
      query: this.leadSearchValue,
      offset: (this.config.page - 1) * this.config.limit
    });
  }

  public get excludedLeadsFilter() {
    if (!this.excludedLeadsIds.length) {
      return {};
    }

    return {
      [`filter[id|${ApiOperators.NOT_EQUAL}]`]: this.excludedLeadsIds.join(",")
    };
  }

  public loadLeads(params) {
    const action = this.$_.isEmpty(params.query) ? Action.LIST : Action.SEARCH;
    if (this.config.action !== action) {
      this.config.page = 1;
    }

    this.loading = true;
    return this.$store
      .dispatch(`data/${DataModules.LEADS}/${action}`, {
        vm: this,
        scope: this.dataScope,
        returnData: false,
        storeData: false,
        params: {
          ...params,
          limit: this.config.limit,
          offset: this.config.offset,
          order: "-created_at",
          "filter[assigned_client_at]": "null",
          with: `${this.isMultibrand ? "brand," : ""}related_leads`,
          ...this.excludedLeadsFilter
        }
      })
      .then(result => {
        this.leads = this.$_.toArray(result.data);
        this.config.total = result.total;
        this.config.action = action;
      })
      .catch(error => {
        this.leads = [];
        this.$store.dispatch("api/handleError", error);
      })
      .finally(() => {
        if (action === Action.LIST) {
          this.config.paginated = true;
        }
        this.loading = false;
      });
  }
}
